/** Select the graph wire format at both portal request boundaries. */
export const portalGraphParams = (endpoint: string, params: Record<string, any> = {}) => {
  const url = new URL(endpoint, "https://portal.invalid/");
  const parts = url.pathname.split("/").filter(Boolean);
  if (!["releases", "sessions", "decisionreports"].includes(parts[0]) ||
      parts.length > 3 || (parts.length === 3 && parts[2] !== "graph")) return params;
  // a list never sends one: the services would read it as a filter on their records (`graph = false`), and lists
  // come without graphs anyway
  if (parts.length === 1) {
    const { graph: _graph, ...rest } = params;
    return rest;
  }
  const requested = params.graph ?? url.searchParams.get("graph");
  const graph = requested === false || requested === "false" ? false
    : requested === "dg" ? "dg"
    : "dg";
  return { ...params, graph };
};
